import styles from '../Product.module.scss';
import cx from 'classnames';
import { ProductCardDescriptionWrapperProps } from '../types';

export const ProductCardDescriptionWrapper = ({
  className,
  children
}: ProductCardDescriptionWrapperProps) => {
  return (
    <div className={cx(styles['product-comparison__card-ellipsis'], className)}>
      {children}
    </div>
  );
};
